<mat-card class="decoration-card">
    <mat-card-content>
        <mat-toolbar *ngIf="!isReadonly">

            <span class="example-spacer"></span>

            <button mat-icon-button class="crud_action" matTooltip="add a test" (click)="createTest()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- SN Column -->
            <ng-container matColumnDef="sn">
                <th mat-header-cell *matHeaderCellDef> SN </th>
                <td mat-cell *matCellDef="let element"> {{element.sn}} </td>
            </ng-container>

            <!-- name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <!-- system Column -->
            <ng-container matColumnDef="system">
                <th mat-header-cell *matHeaderCellDef> System </th>
                <td mat-cell *matCellDef="let element"> {{element.system}} </td>
            </ng-container>

            <!-- subsystem Column -->
            <ng-container matColumnDef="subsystem">
                <th mat-header-cell *matHeaderCellDef> Subsystem </th>
                <td mat-cell *matCellDef="let element"> {{element.subsystem}} </td>
            </ng-container>

            <!-- test objective Column -->
            <ng-container matColumnDef="test_objective">
                <th mat-header-cell *matHeaderCellDef> Test Objective </th>
                <td mat-cell *matCellDef="let element"> {{element.test_objective}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row [class.TestComplated]="row.test_completed" (click)="selectTest(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>